import {
  FADE_IN_ANIMATION,
  SLIDE_UP_ANIMATION,
} from '#app/components/Motion/constants.js';
import { animated } from '#app/components/Primitives/Animated.js';
import { css, styled } from 'styled-components';

export const DrawerScreen = styled.div`
  ${({ theme }) => css`
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: ${theme.zIndices.bottomDrawer.backdrop};
    animation: ${FADE_IN_ANIMATION};
  `}
`;

export const DrawerWrapper = styled(animated.div)<{
  darkMode?: boolean;
  removePaddingOnMobile?: boolean;
}>`
  ${({ darkMode = false, removePaddingOnMobile = false, theme }) => css`
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    position: fixed;
    padding: ${removePaddingOnMobile ? '0' : '8px 16px'};
    bottom: 0px;
    z-index: ${theme.zIndices.bottomDrawer.dialog};
    width: 100%;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    flex: auto;
    background: ${darkMode ? '#262626' : theme.colorsV2.white};
    animation: ${SLIDE_UP_ANIMATION};
  `}
`;

export const CloseIconButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  padding: 16px;
`;

export const DrawerBody = styled.div`
  display: flex;
  flex: auto;
  flex-direction: column;
  overflow-y: auto;

  border-top-right-radius: inherit;
  border-top-left-radius: inherit;
`;

export const DrawerFooter = styled.div`
  padding: 16px 0 24px;

  > * {
    width: 100%;
  }
`;
